import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';
import { UiKitModule } from '../../../shared/modules/ui-kit/ui-kit.module';
import { IconComponent } from '../../atoms/icon/icon.component';
import { gsap } from "gsap";   

@Component({
  selector: 'app-modal-compensacion',
  standalone: true,
  imports: [
    CommonModule,
    CommonNgModule,
    IconComponent,
    UiKitModule
  ],
  templateUrl: './modal-compensacion.component.html',
  styleUrl: './modal-compensacion.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ModalCompensacionComponent {
  @Input() ViewModal:boolean = false;
  @Input() Theme:any;
  @Input() Icono?:boolean;
  @Input() Foo:boolean = true;
  @Input() TituloModal:any;
  @Input() IcoSrc:any;
  @Output() closeModal: EventEmitter<boolean>; 
  @ViewChild("modal") modal!: ElementRef;
  @ViewChildren('element') modalChildren!: QueryList<any>;

  @Input() customIcon?:string;

  tlModal:any;
  listElement:any = [];
  timeTl:any = 1;
  easeTl:any = "power3.out";
  offTimeTl:any = '0.85'


  constructor() {
    this.closeModal = new EventEmitter();
  }
  ngOnInit() {}

  private openModal():void{
    this.tlModal = gsap.timeline({paused: true });
    this.tlModal.fromTo( this.modal.nativeElement ,0.5,{y:50, opacity:0},{y:0, opacity:1,ease: this.easeTl});
    this.tlModal.fromTo(this.listElement[1].nativeElement,this.timeTl, {y:20,opacity:0},{y:0,opacity:1,ease: this.easeTl},'-=0.4');
    this.tlModal.fromTo(this.listElement[2].nativeElement,this.timeTl, {y:20,opacity:0},{y:0,opacity:1,ease: this.easeTl},'-='+this.offTimeTl);
    this.tlModal.fromTo(this.listElement[3].nativeElement,this.timeTl, {y:20,opacity:0},{y:0,opacity:1,ease: this.easeTl},'-='+this.offTimeTl);
    this.tlModal.fromTo(this.listElement[0].nativeElement,this.timeTl, {y:-20,opacity:0},{y:0,opacity:1,ease: this.easeTl},'-='+this.offTimeTl);
    this.tlModal.play();
  }

  ngAfterViewInit(){
    this.listElement = this.modalChildren.toArray();
    this.openModal();
  }

  public cerrarModal():void{
    this.closeModal.emit(this.ViewModal);
    
  }
}
